import styled from "styled-components";
import Button from "@mui/material/Button";
import { AREA_EDIT_COLORS } from "constant/panel";
import { AreaSource } from "type/panel/Panel.type";
import { MouseEventHandler } from "react";
import AreaNav from "../PanelAreaSourceNav/PanelAreaSource/AreaNav";
import useConfirm from "common/modal/ConfirmDialog";

type Props = {
  areas: AreaSource[];
  onNewArea: MouseEventHandler<HTMLButtonElement>;
  onSelectArea: Function;
  onDeleteArea: Function;
  onDeselectArea: MouseEventHandler<HTMLButtonElement>;
};

const PanelAreasNav = ({
  areas,
  onNewArea,
  onDeleteArea,
  onSelectArea,
  onDeselectArea,
}: Props) => {
  const actionConfirm = useConfirm();

  const areaNavs = areas.map((area: any, ind: number) => (
    <Div onClick={() => onSelectArea(ind)} key={`area_nav_${ind}`}>
      <AreaNav backgroundColor={AREA_EDIT_COLORS[ind]} />
    </Div>
  ));

  const areaDeleteHandle = async () => {
    const check = await actionConfirm({
      title: "Area",
      message: "Are you sure you want to delete area",
    });
    if (check) {
      onDeleteArea();
    }
  };

  return (
    <>
      {areaNavs}
      <Button onClick={onNewArea}>New</Button>
      <Button onClick={onDeselectArea}>Deselect</Button>
      <ButtonDelete onClick={areaDeleteHandle}>Delete</ButtonDelete>
    </>
  );
};

const Div = styled.div<{ $backgroundColor?: string }>`
  margin-left: 0.5rem;
`;

const ButtonDelete = styled(Button)`
  margin-left: 2rem;
`;

export default PanelAreasNav;
